import React from "react";
import ShowTable from "./showTable";
import styles from './CustomTable.module.scss';

function BanWebsiteTable({ Data }) {

  const transformedData = Data.data.map((item, index) => {
    const { attributes } = item;
    return {
      Sno: index + 1,
      organisation_name: attributes.organisation_name,
      reported_data_of_block: attributes.reported_data_of_block,
      sources: attributes.sources,
      description: attributes.Description,
      current_status: attributes.current_status,
      number_blocked: attributes.number_blocked,
      kind_of_website:
        attributes.kind_of_websites.data[0]?.attributes.name || "",
      legislation_blocked_under:
        attributes.legislation_blocked_unders.data[0]?.attributes.name || "",
      order_issued_by:
        attributes.order_issued_bies.data[0]?.attributes.name || "",
      reason: attributes.reasons.data[0]?.attributes.name || "",
      type: attributes.types.data[0]?.attributes.name || "",
    };
  });

  const DetailsSort = transformedData
    ?.sort((a, b) => {
      return b.year - a.year;
    })
    .map((item, index) => ({ ...item, index }));

  const columns = [
    {
      name: "S.No",
      selector: (row) => row.index+1,
      center: true,
      minWidth: "50px",
    },
    {
      name: "URLs/Website",
      selector: (row) => row.organisation_name,
      minWidth: "170px",
      wrap: true,
    },
    {
      name: "Reported Data",
      selector: (row) => row.reported_data_of_block,
      minWidth: "130px",
      wrap: true,
      center: true,
    },
    {
      name: "Sources",
      selector: (row) => {
        return (
          <a href={row.sources} target="_blank">
            {row.sources}
          </a>
        );
      },
      minWidth: "400px",
      wrap: true,
      style: {
        margin: "10px 0px",
      },
    },
    {
      name: "Description",
      selector: (row) => row.description,
      minWidth: "450px",
      wrap: true,
    },
    {
      name: "Current Status",
      selector: (row) => row.current_status,
      minWidth: "150px",
      //   wrap: true,
      center: true,
    },
    {
      name: "Number Blocked",
      selector: (row) => row.number_blocked,
      minWidth: "150px",
      wrap: true,
      center: true,
    },
    {
      name: "Kind of website",
      selector: (row) => row.kind_of_website,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "Legislation blocked under",
      selector: (row) => row.legislation_blocked_under,
      minWidth: "200px",
      wrap: true,
    },
    {
      name: "Order Issued By",
      selector: (row) => row.order_issued_by,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "Reason",
      selector: (row) => row.reason,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "Type",
      selector: (row) => row.type,
      minWidth: "150px",
      wrap: true,
    },
  ];

  return <ShowTable title={"Banned Websites Data"} columns={columns} Data={transformedData} />;
}

export default BanWebsiteTable;
